import React, { Fragment, createContext, useReducer } from "react";
import AdminLayout from "../layout";
import DashboardCard from "./DashboardCard";
import Customize from "./Customize";
import TodaySell from "./TodaySell";
import { dashboardState, dashboardReducer } from "./DashboardContext";

export const DashboardContext = createContext();

const DashboardAdmin = (props) => {
  const [data, dispatch] = useReducer(dashboardReducer, dashboardState);

  return (
    <Fragment>
      <DashboardContext.Provider value={{ data, dispatch }}>
        <AdminLayout
          children={
            <Fragment>
              <DashboardCard />
              <Customize />
              <TodaySell />
            </Fragment>
          }
        />
      </DashboardContext.Provider>
    </Fragment>
  );
};

export default DashboardAdmin;
